/* ONZE: Auf dem Handy gleitet jede Produktkarte erst hoch, wenn ihr Bild geladen ist
   und sie im sichtbaren Bereich liegt, leicht gestaffelt. Am Computer passiert hier nichts
   (dort gilt Dawns eigene Einblende-Animation). CSS dazu: assets/onze-header.css.
   Bewusst ohne IntersectionObserver: Position wird direkt gemessen, damit Karten auch dann
   erscheinen, wenn der Browser keine Sichtbarkeits-Meldungen liefert. */
(function () {
  if (window.onzeRevealLoaded) return;
  window.onzeRevealLoaded = true;

  var mobile = window.matchMedia('(max-width: 749px)');
  var queue = [];
  var flushing = false;

  function flush() {
    if (flushing) return;
    flushing = true;
    (function next() {
      var item = queue.shift();
      if (!item) {
        flushing = false;
        return;
      }
      item.classList.add('onze-in');
      setTimeout(next, 90);
    })();
  }

  function whenLoaded(img, cb) {
    if (!img || (img.complete && img.naturalWidth > 0)) return cb();
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      cb();
    }
    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
    setTimeout(finish, 2000);
  }

  function pending() {
    return document.querySelectorAll('.product-grid > .grid__item:not(.onze-in):not([data-onze-reveal])');
  }

  function check() {
    var limit = window.innerHeight * 1.15;
    var items = pending();
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!mobile.matches) {
        item.classList.add('onze-in');
        continue;
      }
      if (item.getBoundingClientRect().top > limit) continue;
      item.setAttribute('data-onze-reveal', '1');
      var img = item.querySelector('.card__media img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
      (function (it, im) {
        whenLoaded(im, function () {
          queue.push(it);
          flush();
        });
      })(item, img);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      check();
    }, 60);
  }

  function start() {
    check();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    // In den ersten Sekunden regelmässig nachsehen (Layout kann sich noch verschieben)
    var runs = 0;
    var poll = setInterval(function () {
      check();
      if (++runs >= 10) clearInterval(poll);
    }, 500);
    // Neu eingefügte Karten (Filter, Sortierung) ebenfalls erfassen
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
